import { ProviderUserProfile } from '@customTypes/user';
import axios from '@hooks/useAxios';

const USER_PROFILE_API_ROUTES = {
  get_user_profile: '/provider-portal/user-profile',
};

export const getUserProfile = async (): Promise<ProviderUserProfile> => {
  return axios.get(USER_PROFILE_API_ROUTES.get_user_profile).then(res => res.data);
};
